// import React from 'react';
// import './About.css';
// import contactpic from '../../assets/contact.png';

// const AboutUs = () => {
//   return (
//     <div className="about-us-section">
//       <div className='container-fluid p-5'>
//         <div className='row align-items-center'>
//           {/* Text Content Column - Animated to slide in from left */}
//           <div 
//             className='col-sm-12 col-md-6 d-flex justify-content-center flex-column gap-3'
//             data-aos="fade-right"
//             data-aos-duration="800"
//             data-aos-easing="ease-out-cubic"
//           >
//             <h1 
//               className="about-us-heading"
//               data-aos="fade-down"
//               data-aos-delay="200"
//               data-aos-duration="600"
//             >
//               100% Trusted Organic Food Store
//             </h1>
//             <p 
//               className="about-us-description"
//               data-aos="fade-up"
//               data-aos-delay="400"
//               data-aos-duration="600"
//             >
//               Morbi porttitor ligula in nunc varius sagittis. Proin dui nisi, laoreet ut tempor ac, 
//               cursus vitae eros. Cras quis ultricies elit. Proin ac lectus arcu. Maecenas aliquet vel 
//               tellus at accumsan. Donec a eros non massa vulputate ornare. Vivamus ornare commodo ante, 
//               at commodo felis congue vitae.
//             </p>
//           </div>

//           {/* Image Column - Animated with zoom effect */}
//           <div 
//             className='col-sm-12 col-md-6 d-flex justify-content-center mt-2'
//             data-aos="zoom-in"
//             data-aos-delay="300"
//             data-aos-duration="1000"
//           >
//             <img 
//               src={contactpic} 
//               className='about-pic-first'
//               data-aos="flip-left"
//               data-aos-delay="500"
//               data-aos-duration="800"
//               alt="Organic food store"
//             />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AboutUs;

import React, { useState, useEffect } from 'react';
import './About.css'; // Make sure your skeleton styles are in this file or imported
// import contactpic from '../../assets/Aboutimage/adult-harvesting-coffee.jpg';
import contactpic from '../../assets/Aboutimage/eea930fd-5d37-4ba2-8aa4-edc96108be2d 1.jpeg';


const AboutUs = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate data fetching or content loading
    const timer = setTimeout(() => {
      setLoading(false); // Set loading to false after a delay (e.g., 2 seconds)
    }, 2000); // Adjust this duration as needed

    // Cleanup the timer if the component unmounts
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="about-us-section">
      <div className='container-fluid p-5'>
        <div className='row align-items-center'>
          {/* Text Content Column */}
          <div
            className='col-sm-12 col-md-6 d-flex justify-content-center flex-column gap-3'
            data-aos="fade-right"
            data-aos-duration="800"
            data-aos-easing="ease-out-cubic"
          >
            {loading ? (
              <>
                <div className="skeleton-line heading"></div>
                <div className="skeleton-line paragraph"></div>
                <div className="skeleton-line paragraph"></div>
                <div className="skeleton-line paragraph"></div>
              </>
            ) : (
              <>
                <h1
                  className="about-us-heading"
                  data-aos="fade-down"
                  data-aos-delay="200"
                  data-aos-duration="600"
                >
                  Powering Kenya’s Agricultural Revolution
                </h1>
                <p
                  className="about-us-description"
                  data-aos="fade-up"
                  data-aos-delay="400"
                  data-aos-duration="600"
                >
                  Volt Harvest Technologies is transforming farming across Kenya through ShambaSync, Africa’s first integrated farm intelligence platform. By combining advanced tools and localized solutions, we’re replacing uncertainty with data-driven, profitable farming.
                </p>
              </>
            )}
          </div>

          {/* Image Column */}
          <div
            className='col-sm-12 col-md-6 d-flex justify-content-center mt-2'
            data-aos="zoom-in"
            data-aos-delay="300"
            data-aos-duration="1000"
          >
            {loading ? (
              <div className="skeleton-image"></div>
            ) : (
              <img
                src={contactpic}
                className='about-pic-first'
                data-aos="flip-left"
                data-aos-delay="500"
                data-aos-duration="800"
                alt="Organic food store"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;